<ng-container *transloco="let translate">
	@if (
		{
			collapsed: sidenavService.collapsed$ | async,
			user: user$ | async,
			quota: quota$ | async,
			isDesktop: isDesktop$ | async,
		};
		as vm
	) {
		<div
			[class.p-0h-l]="!vm.isDesktop"
			[class.p-0h-l]="vm.isDesktop && !vm.collapsed"
			[class.p-0]="vm.isDesktop && vm.collapsed"
			[class.fl-jc-between]="!vm.collapsed"
			[class.fl-jc-c]="vm.collapsed"
			class="w-100 fl fl-ai-c border-box"
			[class.p-1-r]="!vm.collapsed"
		>
			<div
				#mainAnchor
				class="sidenav-logo"
				[class.sidenav-logo--with-title]="useIconWithTitleInSideNav"
				[class.sidenav-logo--collapsed]="vm.collapsed"
			>
				<ng-container *ngIf="useIconWithTitleInSideNav; else defaultSideNavLogo">
					<div class="w-100 fl fl-ai-c fl-gap-1">
						<img
							class="fl-fixed logo-image"
							style="height: 32px; width: 32px"
							src="/assets/images/logo/logo.png"
							alt="Logo"
						/>
						<p class="fl-adaptable ellipsis logo-image">
							{{ appTitle }}
						</p>
					</div>
				</ng-container>
				<ng-template #defaultSideNavLogo>
					<span class="logo-image p-0h">
						<img
							style="width: 96px"
							src="/assets/images/logo/logo-with-text.png"
							alt="myReach"
						/>
					</span>
				</ng-template>
			</div>
			<button
				uiNewButtonIcon
				(click)="toggleCollapsedStatus()"
				[tooltip]="
					!vm.collapsed
						? translate('home.side_navigation.hide_sidenav')
						: translate('home.side_navigation.expand_sidenav')
				"
			>
				<i
					class="icon-double-chevron fs-icon-s"
					[class.chevron-right]="vm.collapsed"
					[class.chevron-left]="!vm.collapsed"
				></i>
			</button>
		</div>
	}
</ng-container>
